import { render } from "./NoticeSection.vue?vue&type=template&id=35186606"
import script from "./NoticeSection.vue?vue&type=script&lang=js"
export * from "./NoticeSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__